import React, { useState } from "react";
import logo from "../../images/blueLogo.png";
import { Link, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useSelector, useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import config from "../../config/config";
import { logoutAction } from "../../redux/actions/logoutAction";
var Constants = require("../constants.json");

const Nav = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const genusList = useSelector((state) => state.genusReducer);
  const genusSelected = localStorage.getItem("genus")
    ? localStorage.getItem("genus")
    : Constants["defaultGenus"];
  const [showmobSearch, setMobSearch] = useState("none");
  const [genus, setGenus] = useState(genusSelected);
  const [searchkey, setSearchkey] = useState("");
  const optionList = props.optionList;
  const { addToast } = useToasts();

  const logoutClicked = (e) => {
    e.preventDefault();
    dispatch(logoutAction());
    history.push("/");
    addToast("You are logged out successfully!", {
      appearance: "success",
      autoDismiss: true,
    });
  };

  const openLoginModal = (e) => {
    e.preventDefault();
    dispatch({ type: "LOGIN_MODAL_OPEN" });
  };

  const logInResponse = useSelector((state) => state.loginReducer);

  function changeSearchkey(e) {
    let srchkey = e.target.value;
    setSearchkey(srchkey);
    props.changeSearchkey(srchkey);
  }
  function handleSearchTopicSubmit(e) {
    e.preventDefault();
    if (searchkey !== "") {
      props.onFormSubmit({ searchkey: searchkey, searchgenus: genus });
    }
  }
  function handleGenusChange(ge) {
    setGenus(ge);
    if (searchkey !== "") {
      props.onFormSubmit({ searchkey: searchkey, searchgenus: ge });
    }
  }
  function showMobSearch(flag) {
    setSearchkey("");
    props.changeSearchkey("");
    setMobSearch(flag);
  }
  const openCloseProfile = () => {
    if (
      document
        .querySelector(".user-arrow")
        .classList.contains("user-arrow-rotate")
    ) {
      document
        .querySelector(".user-arrow")
        .classList.remove("user-arrow-rotate");
      document.querySelector(".profile-dropdown-box").style.display = "none";
    } else {
      document.querySelector(".user-arrow").classList.add("user-arrow-rotate");
      document.querySelector(".profile-dropdown-box").style.display = "block";
    }
  };
  return (
    <div>
      <div className="mobile-search-view" style={{ display: showmobSearch }}>
        <div className="mobile-search-row">
          <div className="mobile-search-input">
            <FontAwesomeIcon icon={faSearch} className="icon" />
            <form
              onSubmit={(e) => handleSearchTopicSubmit(e)}
              className="form-inline"
            >
              <input
                type="text"
                placeholder="Search"
                id="srchNewInput"
                value={searchkey}
                onChange={changeSearchkey}
                autoComplete="off"
              />
            </form>
          </div>
          <p
            className="cancel-search-text"
            onClick={() => showMobSearch("none")}
          >
            Cancel
          </p>
        </div>
        <div className="search-filter-row">
          <p>On This Page</p>
          <p>The Full Site</p>
        </div>
        {genusList && genusList.response && (
          <div className="search-cat-row">
            <label htmlFor="filter">FILTER BY</label>
            <select
              name="genus-list"
              id="genus-list"
              value={genus}
              onChange={(e) => handleGenusChange(e.currentTarget.value)}
            >
              {genusList.response.map((genus) => (
                <option key={genus.id} value={genus.genus}>
                  {genus.genus}
                </option>
              ))}
            </select>
          </div>
        )}
        <div className="recent-search">{optionList}</div>
      </div>
      <div className="nav">
        <div className="mobile-search">
          <FontAwesomeIcon
            icon={faSearch}
            className="icon"
            onClick={() => showMobSearch("block")}
          />
        </div>
        <Link to="/">
          <img src={logo} alt="" />
        </Link>
        <div>
          <div className="user">
            {logInResponse.isLoggedIn ? (
              <>
                <p>{logInResponse.firstName + " " + logInResponse.lastName}</p>
                <span className="user-arrow" onClick={openCloseProfile}>
                  <i className="fa fa-caret-down" aria-hidden="true"></i>
                </span>
                <div className="profile-dropdown-box">
                <a href={`/${config.LOCALE}/checkout/subscription-details`}>
                <p>View Account</p>
                  </a>
                  <p onClick={logoutClicked}>Log Out</p>
                </div>
              </>
            ) : (
              <p onClick={openLoginModal} className="cpointer">
                Login
              </p>
            )}
          </div>
          <div className="mobile-profile">
            <span>
              {logInResponse.isLoggedIn ? (
                logInResponse.firstName[0].toUpperCase()
              ) : (
                <i onClick={openLoginModal} className="fa fa-user"></i>
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Nav;
